import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Download Button Component
 * This component is used to display a download button.
 *
 * @param buttonClass {string} (Optional) Default value is `btn-passive`.
 * @param label {string} (Optional) i18n label already translated. Default value is `dgDownloadableReports_Download`, which
 * translates to `Download`.
 * @param margin {string} ((Optional) Determines where to put margin on the button. Default value is left. Only adds
 *  a `left` or `right` margin of 1
 * @param buttonAction Event emitter to pass the action to be taken back to the parent component.
 *
 * EXAMPLE USAGE:
 * @example
 * ```
 * <dgx-download-button
 *   [buttonClass]="btn-primary"
 *   [margin]="right"
 *   [label]="dgDownloadableReports_Download"
 *   (buttonAction)="downloadReport($event)"
 * >
 * </dgx-download-button>
 * ```
 */
@Component({
    selector: 'dgx-download-button',
    templateUrl: './download-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DownloadButtonComponent {
  @Input() public buttonClass: string = 'btn-passive';
  @Input() public label: string = this.translate.instant(
    'dgDownloadableReports_Download'
  );
  @Input() public margin: string = 'left';
  @Output() public buttonAction: EventEmitter<any> = new EventEmitter();

  constructor(private translate: TranslateService) {}

  /**
   * Apply the class and margin to the button
   * Default class is `btn-passive` and default margin: `left`
   */
  public getButtonClasses(): string {
    return (
      this.buttonClass +
      ' ' +
      (this.margin === 'left'
        ? 'guts-m-l-1'
        : this.margin === 'right'
        ? 'guts-m-r-1'
        : '')
    );
  }
}
